export enum UserPermission {
  SulStaff = "sul_staff",
  ClientPortal = "client_portal",
  Volunteer = "volunteer",
  Supervisor = "supervisor",
  ApiKeyFsw = "api_key_fsw",
  Court = "court",
  CreditorAssoc = "creditor_assoc",
}

export interface UserModel {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  userName: string;
  dateOfBirth: Date;
  permissions: UserPermission[];
  counselorId?: string;
  userCode: string;
}

export interface CurrentUserContextType {
  /**
   * Replace UserModel with you own implementation. This is just an example for showcase
   */
  currentUser: UserModel;
  /**
   *
   * @param permission Replace permission logic with your own implementation
   * @returns
   */
  hasPermission: (permission: UserPermission) => boolean;
}
